export enum VerticalAlign {
  BOTTOM = "bottom",
  CENTER = "center",
  TOP = "top",
}
